import { domScriptInjectAsync } from "@smp/utils";
import { cp } from "custom";
import { useState } from "react";
import { useEffectOnce } from "react-use";

export const useCloudpayments = () => {
  const [widget, setWidget] = useState<InstanceType<cp["CloudPayments"]>>();
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isOpen, setIsOpen] = useState(false);

  const pay = (
    ...params: Parameters<InstanceType<cp["CloudPayments"]>["pay"]>
  ) => {
    if (!widget || isOpen) {
      return;
    } else {
      setIsOpen(true);
      widget.pay(...params);
    }
  };

  useEffectOnce(() => {
    (async () => {
      try {
        if (!window.cp) {
          await domScriptInjectAsync(
            "https://widget.cloudpayments.ru/bundles/cloudpayments",
          );
        }
        if (window.cp) {
          setWidget(new window.cp.CloudPayments());
        }
      } catch (clause) {
        const error = clause as Error;
        setError(error);
      }
    })();
  });

  return { error, isLoaded: !!widget, pay };
};
